import axios from "axios";
const getExperiencesApi = async (
  callback,
  experiencesResData,
  lang,
  baseURL,
  loading
) => {
  loading(true);
  try {
    const response = await axios.get(`${baseURL}/website/experiences`, {
      headers: {
        Accept: "application/json",
        lang: lang,
      },
    });
    // console.log(data);
    experiencesResData(response.data.sectionTitle);
    callback(response.data.data);
    loading(false);
    return;
  } catch (error) {
    loading(false);
    throw new Error(error);
  }
};

export default getExperiencesApi;
